import { UserLimits } from "@modules/core";
import { FeatureState } from "@types";

const videoCallVisibleStates = new Set<FeatureState>([
  FeatureState.Enabled,
  FeatureState.Upgradeable,
]);

const newExternalChatVisibleStates = new Set<FeatureState>([
  FeatureState.Enabled,
  FeatureState.Upgradeable,
]);

const exportCaseToPdfVisibleStates = new Set<FeatureState>([
  FeatureState.Enabled,
  FeatureState.Upgradeable,
]);

/** Shown wherever identity verification is blocked by the user's workspace */
export const IDENTITY_VERIFICATION_DISABLED_MESSAGE =
  "Your workspace has disabled identity verification. If you have any questions, please contact your workspace admin.";

const identityVerificationBlockedStates = new Set<FeatureState>([
  FeatureState.Disabled,
  FeatureState.Unauthorized,
]);

export class UserLimitsUtils {
  public static isVideoCallVisible(userLimits: UserLimits) {
    return videoCallVisibleStates.has(userLimits.video_calls);
  }

  public static isNewExternalChatVisible(userLimits: UserLimits) {
    return (
      userLimits.external_conversations !== undefined &&
      newExternalChatVisibleStates.has(userLimits.external_conversations)
    );
  }

  public static isExternalChatTabVisible(
    userLimits: UserLimits,
    externalConversationCount: number
  ) {
    return (
      userLimits.external_conversations === FeatureState.Enabled ||
      (externalConversationCount &&
        userLimits.external_conversations !== FeatureState.Invisible)
    );
  }

  public static isExportCaseToPdfVisible(userLimits: UserLimits) {
    return (
      userLimits.export_cases !== undefined &&
      exportCaseToPdfVisibleStates.has(userLimits.export_cases)
    );
  }

  public static isAddRoleEnabled(
    userLimits: UserLimits,
    hasWorkspaceTeamManageClaim: boolean
  ) {
    return (
      userLimits.teams === FeatureState.Enabled && hasWorkspaceTeamManageClaim
    );
  }

  /**
   * Identity verification is available unless the user's workspace has
   * disabled it. Limits that haven't loaded, or have no value, don't block it.
   */
  public static isIdentityVerificationAvailable(userLimits: UserLimits | null) {
    return !identityVerificationBlockedStates.has(
      userLimits?.identity_verification
    );
  }
}
